import { render, staticRenderFns } from "./CustomerGroupDetailModal.vue?vue&type=template&id=c70cc39e&scoped=true&"
import script from "./CustomerGroupDetailModal.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroupDetailModal.vue?vue&type=style&index=0&id=c70cc39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70cc39e",
  null
  
)

export default component.exports